import styled, { css } from 'styled-components';
import type { Pane } from './DiffContext';

export const StyledDiffViewContainer = styled.div.attrs({ 'data-testid': 'diff-container' })`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const StyledDiffViewPane = styled.div.attrs({ 'data-diff-pane': '' })`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:first-child {
    border-right: 1px solid var(--cl-gray-400);
  }
`;

export const StyledBadgeContainer = styled.div`
  padding: 10px;
`;

/** Two-column grid for diffing a list of actions */
export const StyledDiffViewGrid = styled.div.attrs({ 'data-testid': 'diff-container' })`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: start;
  width: 100%;
`;

export const StyledDiffViewColumn = styled.div.attrs({
  'data-testid': 'diff-column',
  'data-diff-column': '',
})<{
  pane: Pane;
}>`
  display: flex;
  flex-direction: column;
  min-width: 0;

  ${p => (p.pane === 'left' ? css`
    grid-column: 1;
    border-right: 1px solid var(--cl-gray-400);
    ` : css`
      grid-column: 2;
    `)}
`;

export const StyledDiffViewCardSlot = styled.div.attrs({
  'data-testid': 'diff-card-slot',
  'data-diff-card-slot': '',
})<{
  pane: Pane;
}>`
  padding-bottom: 15px;

  ${p => (p.pane === 'left' ? css`
    padding-right: 15px;
    ` : css`
      padding-left: 15px;
    `)}
`;
